<template>
  <div class="slm-event-list__results">
    <div class="slm-event-list__results-wrapper">
        <div class="slm-event-list__results-header">
            <h2>
                {{result.title}}
            </h2>
            <Filters :id="result.id"/>
        </div>
        <SelectedFilters :id="result.id"/>
        <EventList :events="result.events" v-if="result.total"/>
        <p v-else class="slm-event-list__results-none"> 
          {{noResultsText}}
        </p>
        <Loader v-if="result.loading"/>
        <LoadMore v-if="result.canLoadMore" :id="result.id"/>
    </div>
  </div>
</template>

<script>
import EventList from './EventList.vue';
import Filters from './Filters.vue';
import SelectedFilters from './SelectedFilters.vue';
import Loader from './Loader.vue';
import LoadMore from './LoadMore.vue';

export default {
  name: 'results-component',
  props: ['result', 'title', 'id'],
  computed: {
    noResultsText() {
      return this.$store.state.noResultsText
    }
  },
  components: {
    EventList,
    Filters,
    SelectedFilters,
    Loader,
    LoadMore
  }
}
</script>
